import CONSTANTS from '@/constants'
import api from './api'

const dashboard = {
	getTotalPoints(params) {
		return api.get(`${CONSTANTS.API_BASE_URL}/api/mobile/get_total_points`, { params })
	},
	getMonthlyTargetAchievers(params) {
		return api.get(`${CONSTANTS.API_BASE_URL}/api/mobile/get_monthly_target_achievers`, { params })
	},
	getMostRepeatedCustomers(params) {
		return api.get(`${CONSTANTS.API_BASE_URL}/api/mobile/get_most_repeated_customers`, { params })
	},
	getMostSpendingCustomers(params) {
		return api.get(`${CONSTANTS.API_BASE_URL}/api/mobile/get_most_spending_customers`, { params })
	},
	getActiveInactiveCustomers(params) {
		return api.get(`${CONSTANTS.API_BASE_URL}/api/mobile/get_active_inactive_customers`, { params })
	},
	getUpcomingBirthdays() {
		return api.get(`${CONSTANTS.API_BASE_URL}/api/mobile/get_upcoming_birthdays`)
	},
}

export default dashboard
